import { render, staticRenderFns } from "./CheckoutAddress.vue?vue&type=template&id=15029f0e"
import script from "./CheckoutAddress.vue?vue&type=script&lang=js"
export * from "./CheckoutAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports